import curry from 'ramda/src/curry';
import path from 'ramda/src/path';

export default {
    /**
     * Take an asset, return true if the dimensions match the given width and
     *  height.
     */
    dimensionsOk: curry(function (w, h, asset) {
        var details = path(['advancedDetails', 'image', 0], asset);
        if (!details) return false;
        return details.height == h && details.width == w;
    })
};
